<script setup>
import { useRouter } from 'vue-router';
import { formatRange } from '@/utils/date';
import DateInfo from '@/components/events/DateInfo.vue';
import InfoItem from '@/components/events/InfoItem.vue';
import InPersonVirtualEventTemplate from './InPersonVirtualEventTemplate.vue';

defineProps({
  event: Object,
});

const router = useRouter();
const routeOnRegister = () => router.push({
  path: '/',
});

</script>
<template>
  <in-person-virtual-event-template :event="event" @registered="routeOnRegister">
    <template v-slot:hero-details>
      <div>{{ formatRange(event?.startDateTime)(event?.endDateTime)}}</div>
      <div class="mb-[1.5rem]">{{ event.location }}</div>
    </template>
    <template v-slot:info-details>
      <date-info
        class="mb-[2rem]"
        :startDateTime="event?.startDateTime"
        :endDateTime="event?.endDateTime"
        show-day-of-week
      />

      <info-item
        v-if="event?.time"
        class="mb-[2rem]"
        label="Time"
        :value="event?.time"
      />
      <info-item label="Location" :value="event?.location" />
    </template>
  </in-person-virtual-event-template>
</template>
